import {
  useIntersectionObserver,
  UseIntersectionObserverParams,
} from '@ui/hooks/useIntersectionObserver';
import { Spinner } from '@ui/lib/park/ui/spinner';
import { useEffect, useRef } from 'react';
import { Flex, FlexProps } from 'styled-system/jsx';

type InfiniteLoaderProps = FlexProps &
  Pick<UseIntersectionObserverParams, 'rootMargin'> & {
    hasNext: boolean;
    isPending: boolean;
    fetchNext: () => void;
  };

export const InfiniteLoader = ({
  hasNext,
  isPending,
  fetchNext,
  rootMargin,
  ...props
}: InfiniteLoaderProps) => {
  const { intersectionRef, isIntersecting } =
    useIntersectionObserver<HTMLDivElement>({ rootMargin, threshold: 0 });

  const wasIntersectingRef = useRef(false);
  const lastTriggeredAtRef = useRef(0);
  const COOLDOWN_MS = 800;
  useEffect(() => {
    const entered = !wasIntersectingRef.current && isIntersecting;

    const now = Date.now();
    const cooledDown = now - lastTriggeredAtRef.current > COOLDOWN_MS;

    if (entered && hasNext && !isPending && cooledDown) {
      lastTriggeredAtRef.current = now;

      fetchNext();
    }
  }, [isIntersecting, hasNext, isPending, fetchNext]);

  return (
    <Flex ref={intersectionRef} {...props}>
      <Message hasNext={hasNext} isPending={isPending} />
    </Flex>
  );
};
const Message = ({
  hasNext,
  isPending,
}: Pick<InfiniteLoaderProps, 'hasNext' | 'isPending'>) => {
  if (isPending || hasNext) {
    return (
      <Flex flex={1} justifyContent="center" p={2}>
        <Spinner color="orange" />
      </Flex>
    );
  }

  return;
};
